var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipmentHeavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2",
    "data-name": 2,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562.7,375l15.9-16s24.4-20.9,52.2-11.5c48.4,16.5,104.3-1.4,143.1-40.2,11-11,24.4-33.2,24.4-33.2,1.5-2.1,2.1-4.8,1.4-7.3l-3-12.4c-.6-2.3-2.1-4.3-4.1-5.5-2.1-1.2-4.5-1.5-6.8-.9l-95.3,26.5c-3.5,1-7.3-.3-9.5-3.3l-43.8-60.3c-1.3-1.8-1.9-4.1-1.6-6.3l8.8-64.1c.5-3.5,3-6.3,6.3-7.3l100.6-28c4.5-1.3,7.3-6,6.2-10.6l-4-16.2c-.5-2.3-2-4.2-4-5.5,0,0-7.9-5.2-13.6-8.2-57.2-29.5-129.1-20.4-177.1,27.6-35.4,35.4-49.3,83.9-42.8,129.9,5,35.4,2.7,54.2-12.6,70.4-1.4,1.4-5.8,5.8-12.6,12.5l71.6,69.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.3,461.6c-106.8,103.5-223.3,216.1-223.3,216.1-4,3.8-6.2,9.1-6.3,14.6,0,5.5,2.1,10.8,6,14.6l49.9,49.9c3.9,3.9,9.2,6,14.7,6,5.5,0,10.7-2.3,14.5-6.3l217.7-220.2-73.1-74.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M783.5,705.3c3.9-3.9,6-9.2,6-14.6,0-5.5-2.3-10.7-6.3-14.5l-427.8-416.3-68.7,68.7,417.7,426.4c3.8,4,9,6.2,14.5,6.3s10.8-2.1,14.7-6l49.9-49.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.2,51c-51.5-20.1-134.8-23-183.1,25.2-38,38-93.6,93.6-93.6,93.6-19.8,19.8-1.4,39.4-16,54-14.6,14.6-38,0-51.1,13.2l-48.2,48.3c-6.9,6.8-6.9,18,0,24.8l67.2,67.2c6.9,6.9,18,6.9,24.9,0l48.2-48.2c13.2-13.2-1.5-36.5,13.2-51.1,19.7-19.7,41.2-16.4,53.6-4l24.8,24.8,26.9,7.1,68.7-68.7-7.9-26.1c-21.9-21.9-25-47.3-11.3-61,21.2-21.2,56.3-51.9,89.2-65.1,20.9-8.4,14.6-29.2-5.5-34ZM304,161.7c0,0,9.2-11.4,9.3-11.5l-9.3,11.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentHeavy);
export default __webpack_public_path__ + "static/media/equipment-heavy.d5e6cc54684ee9960ee7c11906435c0f.svg";
export { ForwardRef as ReactComponent };